export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "Crypto-monnaie MetaMask",
            h1B: "Banque de crypto-monnaie MetaMask",
            h1C: "Crypto-monnaie DeFi Wallet",
            h1D: "Banque de crypto-monnaie Coinbase",
            h1E: "Banque d’épargne MetaMask",
            h1F: "Betterment",
            h2: "Inviter des amis",
            h3: "Lier un compte de retrait",
            h4: "Participer à l’épargne",
            h4B: "Dépôt en crypto-monnaie",
            h4C: "Rechargement en monnaie numérique",
            h5: "Produits financiers sélectionnés",
            h5B: "Trading de contrats instantanés",
            h5c: "Déposer",
            h6: "Pool d’utilisateurs",
            h7: "Compte USDT",
            h8: "Production totale",
            h9: "Nœuds actifs",
            h10: "Participants",
            h11: "Revenus",
            h12: "Historique des gains",
            h13: "Adresse",
            h14: "Numéro",
            h15: "FAQ",
            h16: "Comment participer ?",
            h17: "Cher utilisateur, si vous souhaitez participer à l’épargne du portefeuille USDT, vous devez respecter les règles de la plateforme, exécuter strictement les décisions de la plateforme, accepter la supervision du département des risques, et vous obtiendrez automatiquement le droit de dépôt. Bienvenue et merci.",
            h17B: "Cher utilisateur, si vous souhaitez participer à l’épargne du portefeuille USDT, vous devez respecter les règles de la plateforme, exécuter strictement les décisions de la plateforme, accepter la supervision du département des risques, et vous obtiendrez automatiquement le droit de dépôt. Bienvenue et merci.",
            h18: "Comment retirer ?",
            h19: "Les revenus générés chaque jour seront automatiquement crédités sur le solde du compte. Après un retrait USDT réussi, les fonds seront ajoutés automatiquement au portefeuille USDT. Pour un retrait en yen, veuillez contacter le service client. Merci pour votre participation et soutien.",
            h19B: "Les revenus générés chaque jour seront automatiquement crédités sur le solde du compte. Après un retrait USDT réussi, les fonds seront ajoutés automatiquement au portefeuille USDT. Pour d’autres méthodes de retrait, veuillez contacter le service client en ligne !",
            h20: "Comment calculer les revenus ?",
            h21B: "Achat sous forme de cycles, les profits varient selon le niveau VIP\nVIP1  100u~5000u, taux : 1,8%\nVIP2  5000u~20000u, taux : 2,6%\nVIP3  20000u~50000u, taux : 3,5%\nVIP4  50000u~80000u, taux : 4,7%\nVIP5  80000u~120000u, taux : 5,3%\nVIP6  120000u~160000u, taux : 6,2%\nVIP7  160000u~200000u, taux : 7,3%\nVIP8  au-dessus de 200000u, taux : 8%\n\n",
            h21: "Après l’adhésion réussie, le contrat d’épargne commencera à générer des revenus.",
            h22: "D’où viennent les revenus de l’épargne ?",
            h23: "Après que l’utilisateur participe à l’épargne, le contrat prend effet. Les intérêts sont réglés deux fois par jour, à 00h00 et 12h00. Une fois le contrat effectif, les fonds entrent en mode dépôt fiduciaire, et la plateforme est responsable de la sécurité des fonds. Pour garantir la sécurité, veuillez respecter strictement les règles de la plateforme. En cas de problème, contactez le service client en ligne.",
            h23B: "Après que l’utilisateur participe à l’épargne, le contrat prend effet. Les intérêts sont réglés deux fois par jour, à 00h00 et 12h00. Une fois le contrat effectif, les fonds entrent en mode dépôt fiduciaire, et la plateforme est responsable de la sécurité des fonds. Pour garantir la sécurité, veuillez respecter strictement les règles de la plateforme. En cas de problème, contactez le service client en ligne.",
            h24: "Quel est le montant de la prime ?",
            h25: "Vous pouvez partager notre plateforme avec vos amis. Lorsqu’un ami participe, vous recevrez 20% de sa première mise et 10% de commission permanente sur ses revenus. Le lien public de partage se trouve en haut à droite de la page d’accueil.",
            h25B: "Vous pouvez partager cette plateforme avec vos amis. Lorsqu’un ami participe, vous recevrez 20% de sa première mise et 10% de commission permanente sur ses revenus. Le lien de partage se trouve en haut à droite de la page d’accueil.",
            h26: "Solde disponible",
            h27: "Montant du dépôt",
            
            h88: "Contexte de la plateforme",
            h89: "Betterment\nFondé : 2008\nSiège : New York, États-Unis\nPositionnement : Robo-Advisor et FinTech, proposant des portefeuilles automatisés et gestion de trésorerie\nRégulation : régulé par la SEC et membre de la FINRA\nClients : plus de 40 milliards USD d’actifs sous gestion\nUtilisateurs : plus de 800 000 particuliers et entreprises",
            h90: "Avantages de la plateforme",
            h91: "✔️ L’un des premiers Robo-Advisors aux États-Unis, expérience solide\n✔️ Portefeuille basé sur la théorie moderne de l’allocation d’actifs (MPT), diversification des risques\n✔️ Fonction d’optimisation fiscale\n✔️ Compte à haut rendement et haute liquidité\n✔️ Processus entièrement digitalisé, interface simple",
            h92: "Public cible",
            h93: "★ Utilisateurs recherchant un investissement à long terme et stable\n★ Jeunes investisseurs voulant une gestion automatisée, simple et rapide\n★ Personnes souhaitant combiner investissement + épargne à haut rendement + comptes de retraite\n★ Investisseurs ordinaires souhaitant accéder aux marchés financiers à faible coût",
            
            h28: "Revenus d’aujourd’hui",
            h29: "Revenus totaux",
            h30: "Retrait",
            h31: "Historique",
            h32: "Solde disponible",
            h33: "Montant du retrait",
            h34: "Veuillez entrer le montant du retrait",
            h35: "Tout",
            h36: "Retirer",
            h37: "FAQ",
            h38: "Rapport d’audit de sécurité",
            h39: "Partenaires",
            h40: "Nos partenaires commerciaux",
            h41: "Afficher le numéro de carte bancaire",
            h42: "Page précédente",
            h43: "Page suivante",
            h44: "C’est déjà la première page",
            h45: "Veuillez entrer le montant du retrait",
            h46: "Solde insuffisant",
            h47: "C’est déjà la dernière page",
            h48: "Revenus",
            h49: "Dépenses",
            h50: "Trop d’opérations, veuillez réessayer plus tard.",
            h51: "Rapport d’audit",
            h52: "Épargne en cryptomonnaie",
            h521: "Épargne par dépôt",
            h53: "Transactions d’ordres",
            h54: "Prime d’inscription",
            h55: "Prime d’invitation",
            h56: "Retrait",
            h57: "Rechargement",
            h58: "Dépôt",
            h59: "Retrait",
            h591: "Dépôt réussi",
            h592: "Échec du dépôt",
            h593: "Solde insuffisant",
            h60: "Offrir des USDT par transfert crypto",
            h61: "Merci aux utilisateurs qui soutiennent la banque MetaMask. Pour faciliter l’épargne, utilisez un transfert crypto (USDT ETH BTC) et recevez une prime : dépôt ≥1000 USDT → bonus 30 USDT, ≥5000 USDT → 200 USDT, ≥10000 USDT → 5% de bonus. (Applicable aussi pour les retraits via portefeuille crypto)",
            h61B: "Merci aux utilisateurs qui soutiennent la banque Coinbase. Pour faciliter l’épargne, utilisez un transfert crypto (USDT ETH BTC) et recevez une prime : dépôt ≥1000 USDT → bonus 30 USDT, ≥5000 USDT → 200 USDT, ≥10000 USDT → 5% de bonus.",
            h61C: "Merci aux utilisateurs qui soutiennent la banque MetaMask. Pour faciliter l’épargne, utilisez un transfert crypto (USDT ETH BTC) et recevez une prime : dépôt ≥1000 USDT → bonus 30 USDT, ≥5000 USDT → 200 USDT, ≥10000 USDT → 5% de bonus.",
            h61D: "Merci aux utilisateurs qui soutiennent Betterment. Pour faciliter l’épargne, utilisez un transfert crypto (USDT ETH BTC) et recevez une prime : dépôt ≥1000 USDT → bonus 30 USDT, ≥5000 USDT → 200 USDT, ≥10000 USDT → 5% de bonus.",
            h62: "Votre montant de retrait est {amount}, les frais sont de {fee}% !",
            h63: "Confirmer",
            h99: "Bientôt disponible",
        },
        bankcard: {
            b1: "Compte bancaire",
            b2: "Nom de l’institution financière",
            b3: "Veuillez entrer le nom de l’institution financière",
            b4: "Nom de l’agence",
            b5: "Veuillez entrer le nom de l’agence",
            b6: "Numéro de l’agence",
            b7: "Veuillez entrer le numéro de l’agence",
            b8: "Compte (ordinaire)",
            b9: "Veuillez entrer le numéro de compte",
            b10: "Nom phonétique",
            b11: "Veuillez entrer le nom d’utilisateur",
            b12: "Titulaire du compte",
            b13: "Veuillez entrer le nom du titulaire",
            b14: "Lier",
            b15: "Adresse de portefeuille crypto",
            b16: "Veuillez entrer l’adresse crypto",
        },
        usdt: {
            u1: "Mes ordres",
            u2: "Déposer",
            u3: "Veuillez choisir la durée du contrat :",
            u4: "Prix d’achat :",
            u5: "Veuillez entrer le montant du dépôt",
            u6: "Augmenter l’achat",
            u7: "Réduire l’achat",
            u8: "Opération réussie",
            u9: "Au moins un peu",
        },
        order: {
            o0: "Mes ordres",
            o1: "Numéro de commande",
            o2: "Type de commande",
            o3: "Montant d’achat",
            o4: "Montant de vente",
            o5: "Montant payé",
            o6: "Durée du contrat",
            o7: "Statut de la commande",
            o8: "Statut du règlement",
            o9: "Heure du règlement",
            o10: "Heure de la commande",
            o11: "Augmenter l’achat",
            o12: "Réduire l’achat",
            o13: "Vendu",
            o14: "Profit",
            o15: "Perte",
            o16: "Payé",
            o17: "Point mort (seuil de rentabilité)",
        },
        recharge: {
            r1: "Montant du rechargement",
            r2: "Montant rechargé",
            r3: "Type de rechargement",
            r4: "Veuillez sélectionner",
            r5: "Adresse de rechargement",
            r6: "Numéro de transaction du transfert",
            r7: "Transfert effectué",
            r8: "En cours de vérification",
            r9: "Entrée incorrecte",
            r10: "Veuillez choisir une méthode de paiement",
            r11: "Montant minimum de rechargement",
            r12: "Montant maximum de rechargement",
            r13: "Veuillez entrer le montant",
            r14: "Télécharger la capture d’écran du paiement",
            r15: "Veuillez télécharger la capture d’écran du paiement",
            r16: "Soumis avec succès",
            r17: "Annuler",
            r18: "Confirmer",
        },
        rechargeDetails: {
            r1: "Historique de rechargement",
            r2: "Montant rechargé",
            r3: "En cours de vérification",
            r4: "Rechargement réussi",
            r5: "Échec du rechargement",
        },
		cert: {
		    c1: "Vérification d'identité",
		    c2: "Nom réel",
		    c21: "Veuillez saisir votre nom réel",
		    c3: "Type de document",
		    c31: "Carte d'identité",
		    c32: "Passeport",
		    c33: "Permis de conduire",
		    c10: "Saisissez le type de document",
		    c4: "Recto du document",
		    c41: "Veuillez télécharger le recto du document",
		    c5: "Verso du document",
		    c51: "Veuillez télécharger le verso du document",
		    c6: "Soumettre",
		    c7: "Soumis avec succès, en attente de vérification...",
		    c8: "Vérification approuvée",
		    c9: "La vérification d'identité a échoué, veuillez télécharger à nouveau les documents",
		    c11: "En cours de vérification",
		    "传入字段不完整": "Champs requis incomplets",
		    "已认证过": "Déjà vérifié",
		    "审核中": "En cours de vérification"
		}
		 }